import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatPrice } from "@/lib/api";

export const DesignStrip = ({ productId }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems([]);
    api.get(`/products/${productId}/same-design`)
      .then((r) => setItems(r.data || []))
      .catch((e) => console.warn("Same-design products failed to load", e));
  }, [productId]);
  if (!items.length) return null;

  return (
    <section data-testid="same-design-strip" className="mt-14">
      <div className="flex items-baseline justify-between gap-4">
        <h2 className="font-display text-base md:text-lg">More from this design</h2>
        <span className="text-xs uppercase tracking-widest text-muted-foreground">{items.length} more</span>
      </div>
      <div className="mt-4 -mx-6 px-6 scroll-px-6 md:mx-0 md:px-0 md:scroll-px-0 flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3">
        {items.map((p) => (
          <Link
            key={p.id}
            to={`/product/${p.id}`}
            data-testid={`same-design-item-${p.id}`}
            aria-label={p.title}
            title={p.title}
            className="group snap-start shrink-0 w-36 md:w-44 border border-border bg-white rounded-sm overflow-hidden hover:-translate-y-1 transition-transform"
          >
            <div className="aspect-square bg-muted overflow-hidden">
              {p.default_image && (
                <img src={p.default_image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              )}
            </div>
            <div data-testid={`same-design-price-${p.id}`} className="px-3 py-2 font-display text-sm text-[#C84A31]">
              {formatPrice(p.min_price)}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
